<template>
  <HoverTooltip
    tip="Click & hold"
    placement="top"
    class="max-w-fit"
  >
    <button
      type="button"
      class="relative text-left z-10 flex max-w-fit cursor-pointer select-none items-center justify-center self-end rounded transition-all has-tooltip parent delete-container long-delete hover:text-red-600 hover:opacity-100 focus:outline-none focus:ring ring-offset-2 ring-bdBlue-200"
      :class="containerClasses"
      @mousedown="startDelete"
      @mouseup="mouseUp"
      @touchstart="startDelete"
      @touchend="mouseUp"
    >
    <span class="block h-11 w-11 min-w-11 relative">
      <svg
        height="40"
        width="40"
        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        fill="transparent"
        style="z-index: -1"
      >
        <circle cx="20" cy="20" r="14" />
      </svg>
      <TrashIcon class="w-4 h-4 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"/>
    </span>
    <span
      v-if="hasSlot"
      class="block whitespace-nowrap pr-4 font-medium">
      <slot />
    </span>
    <span
      v-if="message"
      class="absolute bottom-8 left-1/2 mb-1 -translate-x-1/2 whitespace-nowrap rounded bg-black/75 px-3 py-1 text-sm text-white child-hover"
    >
      {{ message }}
    </span>
    </button>
  </HoverTooltip>
</template>

<script setup>
import {TrashIcon} from "@heroicons/vue/20/solid";
import HoverTooltip from "./HoverTooltip.vue";
import {computed} from "vue";

const emits = defineEmits(["delete"]);
const props = defineProps({
  message: {
    type: String,
    default: "",
  },
  windowConfirm: {
    type: Boolean,
    default: false,
  },
  confirmationMessage: {
    type: String,
    default: "",
  },
  hideBg: {
    type: Boolean,
    default: false,
  },
  hasSlot: {
    type: Boolean,
    default: false,
  }
});

let mouseTimeout;

const mouseUp = () => {
  clearTimeout(mouseTimeout);
};

const startDelete = () => {
  clearTimeout(mouseTimeout);
  mouseTimeout = setTimeout(function () {
    if (props.windowConfirm && !confirm(props.confirmationMessage)) return;
    emits("delete");
  }, 580);
};

const containerClasses = computed(() => {
  if (props.hideBg) return "text-slate-400";
  return "flex items-center justify-center bg-slate-100 text-slate-600 hover:bg-red-100 active:bg-red-100 rounded-xl";
});
</script>

<style scoped>
.delete-container:active circle {
  fill: transparent;
  stroke: rgb(220 38 38);
  stroke-width: 3;
  stroke-dasharray: 250;
  stroke-dashoffset: 250;
  animation: rotate 1500ms linear forwards;
}

@keyframes rotate {
  to {
    stroke-dashoffset: 0;
  }
}

.child-hover {
  display: none;
}

.parent:hover .child-hover {
  display: block;
}
</style>
